const
    CARD_TYPE_ATTR = 'data-card-type',
    HIDDEN_CLASS = 'is-hidden',
    SELECTED_CLASS = 'is-selected',
    CARD_LIST_SELECTOR = '.card-field--cardlist';

let $cardList, $cvvCardList, $cvvField;

export default function ( el, options = {
    cvvFieldId: '#CVVCode',
    cvvCardListSelector: '.cvv-display-item',
    cardListSelector: '.credit-cards'
} ) {
    var $select = $( el );
    $cardList = $( options.cardListSelector );
    $cvvCardList = $( options.cvvCardListSelector );
    $cvvField = $( options.cvvFieldId );
    $select.on( 'change', onChange );

    if ( $select.val() ) {
        onChange.call( $select[0] );
    }
}

function onChange () {
    var cardType = this.value.toLowerCase(),
        cvvLength = (cardType === 'amex' ? 4 : 3);

    $( CARD_LIST_SELECTOR ).toggleClass( SELECTED_CLASS, !!cardType );
    showSelectedCard( cardType );
    showSelectedCvvDisplay( cardType );

    $cvvField
        .attr( 'minlength', cvvLength )
        .attr( 'maxlength', cvvLength );

    $( document ).trigger( 'field:validate-if-needed', $cvvField );
}

function showSelectedCard ( cardType ) {
    $cardList.find( 'li' ).each( function ( i, item ) {
        if ( !cardType ) {
            $( item ).removeClass( HIDDEN_CLASS ).removeClass( SELECTED_CLASS );
        }
        else {
            $( item ).addClass( HIDDEN_CLASS ).removeClass( SELECTED_CLASS );
        }

        if ( item.getAttribute( CARD_TYPE_ATTR ) === cardType ) {
            $( item ).addClass( SELECTED_CLASS ).removeClass( HIDDEN_CLASS );
        }
    } );
}

function showSelectedCvvDisplay ( cardType ) {
    $cvvCardList.each( function ( i, item ) {
        if ( !cardType || item.getAttribute( CARD_TYPE_ATTR ).indexOf( cardType ) <= -1 ) {
            $( item ).addClass( HIDDEN_CLASS );
        }
        else {
            $( item ).removeClass( HIDDEN_CLASS );
        }
    } );
}